import { Input } from '@common/components/Input'
import { EmailOptions } from '@common/utils/forms'
import { ButtonContainer } from '@common/components/ButtonContainer'
import { Button } from '@common/components/Button'
import { useForm } from 'react-hook-form'
import {
  Dialog,
  DialogContainer,
  DialogHeader,
  DialogSubtitle,
  DialogTopTitle,
} from './Dialog.styles'

export const CaptureEmailDialog = ({
  defaultValue,
  onNext,
  onBack,
}: {
  defaultValue: string
  onNext: (email: string) => void
  onBack: () => void
}) => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm<{ email: string }>({ defaultValues: { email: defaultValue } })

  const handleSubmitEmail = () => {
    onNext(getValues('email'))
  }

  return (
    <DialogContainer onSubmit={handleSubmit(handleSubmitEmail)}>
      <Dialog>
        <DialogTopTitle>Steg 2 av 3</DialogTopTitle>
        <DialogHeader>Vad är din e-mail?</DialogHeader>
        <DialogSubtitle>Den kommer användas för att logga in på hemsidan.</DialogSubtitle>
        <div style={{ marginTop: '1rem' }} />
        <Input
          autoFocus
          error={errors.email?.message}
          placeholder="mail@gmail.com"
          type="email"
          {...register('email', EmailOptions)}
        />
        <div style={{ marginTop: '1rem' }} />
        <ButtonContainer>
          <Button type="submit" disabled={!isValid}>
            Nästa
          </Button>
          <Button
            variant="secondary"
            onClick={(e) => {
              onBack()
              e.preventDefault()
            }}
          >
            Tillbaka
          </Button>
        </ButtonContainer>
      </Dialog>
    </DialogContainer>
  )
}
